import {useState, createContext, useEffect} from 'react';
import { changeDisable, setMaskGeneric, setMaskHour, viewItem, getPermission, getParameter, showMessageError } from '../../../classes/functions';
import ModalDialog from '../../../components/Modal';
import './order.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import InputDate from '../../../components/Inputs/Date/index.js';

export default function Order(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
    
  const [listStatus, setListStatus] = useState([]);
  const [listSearchCliente, setListSearchCliente] = useState([]);

  const [status, setStatus] = useState('');
  const [hora_abertura, setHoraAbertura] = useState('');
  const [documento, setDocumento] = useState('');
  const [servico, setServico] = useState('');
  const [tarefa, setTarefa] = useState('');
  const [nome_cliente, setNomeCliente] = useState('');
  const [cliente, setCliente] = useState('');
  const [hora_finalizacao, setHoraFinalizacao] = useState('');
  const [usuario, setUsuario] = useState('');
  const [rows, setRows] = useState([]);
  
  const [listSearchService, setListSearchService] = useState([]);
  const [nome_servico, setNomeServico] = useState('');

  const [listSearchDocuments, setListSearchDocuments] = useState([]);
  const [numero_documento, setNumeroDocumento] = useState('');

  const [listTasks, setListTasks] = useState([]);
  const [listProducts, setListProducts] = useState([]);
  const [listFeatures, setListFeatures] = useState([]);

  const [infos, setInfos] = useState({
    data_abertura: "",
    data_finalizacao: ""
  });

  useEffect(()=> {
    async function loadOrder(){
      if (id) {
        getOne(id, option);
      }
    }

    getData();
    loadOrder();

  },[]);

  function validForm() {
    if ((status != '')) {
      return true;
    } else {
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();

    if (validForm() == true) {
      const data = {
        row: {
          status: status,
          data_abertura: infos.data_abertura,
          hora_abertura: hora_abertura,
          documento: documento,
          servico: servico,
          tarefa: tarefa,
          cliente: cliente,
          data_finalizacao: infos.data_finalizacao,
          hora_finalizacao: hora_finalizacao,
          usuario: usuario,
        }
      }

      if (id) { 
        data.row.id = id;
        api.put("/api/order_services/put", data)
        .then((response) => {
            toast.success('Registro atualizado com sucesso.');
            history.push('/order_services');
          }
        ).catch((error) => {
          console.log(error);
          showMessageError(error.response.data);
          setCarrying(false);
        });
      } else {
        api.post("/api/order_services/post", data)
        .then((response) => {
            toast.success('Registro inserido com sucesso.');
            history.push('/order_services');
          }
        ).catch((error) => {
          console.log(error);
          showMessageError(error.response.data);
          setCarrying(false);
        });
      }
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      setCarrying(false);
    }
  }

  function getOne(id, option){
    api.get("/api/order_services/getList?id=" + id)
    .then((response) => {
      setStatus(response.data.row.status);
      setInfos((prevState) => ({...prevState, data_abertura: response.data.row.data_abertura, data_finalizacao: response.data.row.data_finalizacao}));
      setHoraAbertura(response.data.row.hora_abertura);
      setNumeroDocumento(response.data.row.numero_documento);
      setDocumento(response.data.row.documento);
      setNomeServico(response.data.row.nome_servico);
      setServico(response.data.row.servico);
      setTarefa(response.data.row.tarefa);
      setCliente(response.data.row.cliente);
      setNomeCliente(response.data.row.nome_cliente);
      setHoraFinalizacao(response.data.row.hora_finalizacao);
      setUsuario(response.data.row.usuario);
      
      setRows(response.data.rows);
      
      setCarrying(false);
    }).catch((error) => {
      console.log(error);
      showMessageError(error.response.data);

      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/order_services');
  }

  function remove(){
    api.delete("/api/order_services/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/order_services');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }
  
  async function getData() {
    api.get("/api/order_services/getDataPage")
    .then((response) => {
      setListStatus(response.data.status);
      setListTasks(response.data.tarefas);
      setListProducts(response.data.products);
      setListFeatures(response.data.features);

      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function searchClient(e) {
    api.get("/api/entry_documents/searchPeople?term=" + e.target.value.toLowerCase())
    .then((response) => {
      setListSearchCliente(response.data.people);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
    setNomeCliente(e.target.value);
  }

  async function selectClient(item) {
    setCliente(item.id);
    setNomeCliente(item.nome);
    
    setListSearchCliente([]);
  }
  
  function searchDocuments(e) {
    api.get("/api/entry_documents/searchDocuments?term=" + e.target.value.toLowerCase())
    .then((response) => {
      setListSearchDocuments(response.data.entradas);
    }).catch((error) => {
      showMessageError(error.response.data);
    });

    setNumeroDocumento(e.target.value);
  }

  function selectDocument(item) {
    setDocumento(item.id);
    setNumeroDocumento(item.numero_documento);

    setListSearchDocuments([]);
  }

  function searchService(e) {
    api.get("/api/service/searchService?term=" + e.target.value.toLowerCase())
    .then((response) => {
      setListSearchService(response.data.services);
    }).catch((error) => {
      showMessageError(error.response.data);
    });

    setNomeServico(e.target.value);
  }

  function selectService(item) {
    setServico(item.id);
    setNomeServico(item.nome);

    setListSearchService([]);
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Ordem de Serviço">
          <Link to="/order_services">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
            
              <div className="divGroup">
                <div className="formDiv">
                  <label>Status</label><br/>
                  <select value={status} onChange={ (e) => setStatus(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listStatus.map((item, index) => (
                      <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Data de Abertura</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_abertura" disabled={(view || id)} />
                </div>

                <div className="formDiv">
                  <label>Hora de Abertura</label><br/>
                  <input type="text" placeholder="##:##:##" value={hora_abertura} onChange={ (e) => setHoraAbertura(setMaskHour(e.target.value, "##.##.##"))} maxLength="8" disabled={view || id}/>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Número do Documento</label><br/>
                  <input type="text" placeholder="Número do Documento" value={numero_documento} onChange={searchDocuments} maxLength="12" />
                  <ul className="dropdown-menu" id="transportDatalist">
                    {listSearchDocuments.map((item, index) => (
                      <li key={index} onClick={() => selectDocument(item)}>
                        <a>{item.serie_documento} - {item.numero_documento}</a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="formDiv">
                  <label>Serviço</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Serviço" value={nome_servico} onChange={searchService} maxLength="60" disabled={view || id}/>
                  <ul className="dropdown-menu" id="serviceDatalist">
                    {listSearchService.map((item, index) => (
                      <li key={index} onClick={() => selectService(item)}>
                        <a>{item.nome}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="formDiv">
                  <label>Tarefa</label><br/>
                  <select value={tarefa} onChange={ (e) => setTarefa(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listTasks.map((item, index) => (
                      <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Cliente/Fornecedor</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Cliente/Fornecedor" value={nome_cliente} onChange={searchClient} maxLength="60" disabled={view || id}/>
                  <ul className="dropdown-menu" id="transportDatalist">
                    {listSearchCliente.map((item, index) => (
                      <li key={index} onClick={() => selectClient(item)}>
                        <a>{item.nome}</a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="formDiv">
                  <label>Data de Finalização</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_finalizacao" disabled={view} />
                </div>

                <div className="formDiv">
                  <label>Hora de Finalização</label><br/>
                  <input type="text" placeholder="##:##:##" value={hora_finalizacao} onChange={ (e) => setHoraFinalizacao(setMaskHour(e.target.value, "##.##.##"))} maxLength="8" disabled={view}/>
                </div>
              </div>
            </div>
            <br/>
            {rows.length > 0 && <div className="divGroup">
              <div className="formDivList">
                <div className="containerGroupData">
                  <h2>Itens&nbsp;<label className="required">*</label></h2>
                  <hr></hr>
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Produto</th>
                        <th scope="col">Característica</th>
                        <th scope="col">Quantidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((form_item, index)=>{
                        return(
                          <tr key={index}>
                            <td>{viewItem(listProducts, form_item.id_produto)}</td>
                            <td>{viewItem(listFeatures, form_item.id_caracteristica_produto)}</td>
                            <td>{form_item.quantidade}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
            {!view && <div className="formDiv">
              {getPermission('OPERACOES - ORDEM SERVICO - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('OPERACOES - ORDEM SERVICO - EXCLUSÃO') && <button type="button" className="buttonRemove" onClick={remove} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}